import { Widgets } from '@common/enums';

export const widgetsNamesMap: Partial<Record<Widgets, string>> = {
    [Widgets.ACCORDION]: 'widget_accordion_label',
    [Widgets.PAYMENT_FORM]: 'widget_payment_form_label',
    [Widgets.TIMER]: 'widget_timer_label',
    [Widgets.SHOP_CART]: 'widget_shop_cart_label',
    [Widgets.PRODUCT_CARD]: 'widget_product_card_label',
    [Widgets.BEFORE_AFTER]: 'widget_before_after_label',
    [Widgets.CATALOG_PRODUCTS]: 'widget_catalog_products_label',
    [Widgets.CODE]: 'widget_code_label',
};

export function getWidgetName(widgetName: Widgets): string {
    if (widgetName in widgetsNamesMap) {
        return widgetsNamesMap[widgetName];
    }

    return `Unknown widget: ${widgetName}`;
}
